import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import withAppShell from '../../hoc/withAppShell/WithAppShell';
import { } from "../../../store";
import spinner from "../../ui/icons/spinner.gif";
import { MuiTypography, MuiGrid, MuiAddCircle, MuiButton } from '../../ui/MaterialUIComponents'
import theme from "../../../assests/theme"
import SubscriptionComponent from './SubscriptionComponent'
import { SchoolInformationActions, SubscriptionActions } from '../../../store'
import CreateNewSchoolStepsCardComponent from '../dashboard/CreateNewSchoolStepsCardComponent'
import paddleConfig from '../../../security/paddleConfig.json'
import lodashUtil from 'lodash'
import { getKeyFromLS, setDataInLS } from '../../../utils/LocalStorageUtil'
import { toast } from 'react-toastify';
import { deleteSchoolInProgress } from '../../../store/schoolInformation/SchoolInformationActions';
const Paddle = window.Paddle;

class SubscriptionContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isButtonDisabled: false
    }
  }
  componentWillMount() {
    this.props.getSchoolsSummary(this.props.userInformation._id)
    let i18n, isButtonDisabled = false;
    if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
      i18n = getKeyFromLS("i18n");
    } else {
      i18n = this.props.i18n
    }
    
    let transactionTime = getKeyFromLS("licenseTransaction")
    if (transactionTime != undefined) {
      let dif = (new Date() - new Date(transactionTime.date));
      dif = Math.round((dif / 1000) / 60);
      if (dif < 7) {
        isButtonDisabled = true
      }
    }

    this.setState({
      i18n: i18n,
      isButtonDisabled: isButtonDisabled
    })
  }

  getSubscription = async (event, school, numberOfSections) => {
    event.preventDefault();
    // let license = await this.props.getSubscription(school, numberOfSections, this.props.userInformation._id)
    // if (this.props.getSubscriptionFailed) {
    //   toast(this.props.i18n.license.subscriptionFailed);
    // } else {
    //   toast(this.props.i18n.license.subscriptionSuccess);
    // }
    Paddle.Setup({ vendor: paddleConfig.paddleVendorId });
    Paddle.Checkout.open({
      product: paddleConfig.paddleSubscriptionPlanID,
      email: school.email,
      quantity: numberOfSections,
      allowQuantity: false,
      passthrough: { schoolId: school._id },
      successCallback: async (data, err) => {
        let message = undefined;
        if (data.checkout.completed) {
          await this.props.getSchoolsSummary(this.props.userInformation._id)
          toast.success(this.state.i18n.license.subscriptionSuccess);
          setDataInLS("licenseTransaction", { date: new Date() })
          this.setState({
            showPaymentNotifier: true,
            message: message,
            isButtonDisabled: true
          })
        } else {
          toast.error(this.state.i18n.license.subscriptionFailed);
          this.setState({
            showPaymentNotifier: true,
            message: message,
          })
        }
      }
    });
  };

  addMoreTimetables = async (event, school) => {
    event.preventDefault();
    Paddle.Setup({ vendor: paddleConfig.paddleVendorId });
    Paddle.Checkout.open({
      product: paddleConfig.paddleProductID,
      email: school.email,
      passthrough: { schoolId: school._id },
      successCallback: async (data, err) => {
        let message = undefined;
        if (data.checkout.completed) {
          await this.props.getSchoolsSummary(this.props.userInformation._id)
          toast.success(this.state.i18n.license.addMoreTimetablesSuccess);
          setDataInLS("licenseTransaction", { date: new Date() })
          this.setState({
            showPaymentNotifier: true,
            message: message,
            isButtonDisabled: true
          })
        } else {
          toast.error(this.state.i18n.license.addMoreTimetablesFailed);
          this.setState({
            showPaymentNotifier: true,
            message: message,
          })
        }
      }
    });
  };
  getNoSchoolComponent = () => {
    
    return (<MuiGrid container style={{ marginTop: '75px' }} alignItems='center' justify='center' xs={12}>
      <MuiGrid xs={10}>
        <CreateNewSchoolStepsCardComponent {...this.props} {...this.state} />
      </MuiGrid></MuiGrid>)
  }
  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["manageLicense"];
    if (content !== undefined) {
      props.toggleDrawer("right", true, content)(event)
    }
  }
  deleteSchool = async (schoolId) => {
    let res = await this.props.deleteSchool(this.props.userInformation._id, schoolId)
    if (res.status === 200) {
      //document.location.href = '/';
      toast.success(this.state.i18n.license.deleteSchoolSuccess)
    } else if (res.status === false) {
      toast.error(res.result.message);
    }
  }

  updateSubscription = async (ownerId, subscribingPackage) => {
    
    let res = await this.props.addMoreSectionsToSubscription(ownerId, subscribingPackage)
    if (res.status === true) {
      toast.success(this.state.i18n.license.updateSubscriptionSuccess)
      this.setState({
        isButtonDisabled: true
      })
    } else {
      toast.error(this.state.i18n.license.updateSubscriptionFailed)
    }
  }

  render() {
    console.log(this.props)
    console.log(this.props.getSchoolsSummaryInProgress || this.props.getSubscriptionInProgress || this.props.cancelSubscriptionInProgress || this.props.addMoreSectionsToSubscriptionInProgress)
    
    return <MuiGrid xs={12}>
      {(this.props.getSchoolsSummaryInProgress || this.props.getSubscriptionInProgress || this.props.cancelSubscriptionInProgress || this.props.addMoreSectionsToSubscriptionInProgress ? <img src={spinner} alt="Loading..." style={theme.spinnerImgStyle} />: (
        <div> {this.props.schoolsSummary && this.props.schoolsSummary.length > 0 ? (<SubscriptionComponent {...this.props} {...this.state} getSubscription={this.getSubscription} addMoreTimetables={this.addMoreTimetables} showContextualHelp={this.showContextualHelp} deleteSchool={this.deleteSchool} updateSubscription={this.updateSubscription} />) : this.getNoSchoolComponent()}</div>
      ))}
    </MuiGrid>
  }
}
const mapDispatchToProps = (dispatch) => ({
  getSchoolsSummary: (ownerId) => dispatch(SchoolInformationActions.getSchoolsSummary(ownerId)),
  addMoreSectionsToSubscription: (ownerId, subscribingPackage) => dispatch(SubscriptionActions.addMoreSectionsToSubscription(ownerId, subscribingPackage)),
  addMoreTimetablesToSubscription: (ownerId, subscribingPackage) => dispatch(SubscriptionActions.addMoreTimetablesToSubscription(ownerId, subscribingPackage)),
  cancelSubscription: (ownerId, subscribingPackage) => dispatch(SubscriptionActions.cancelSubscription(ownerId, subscribingPackage)),
  getSubscription: (school, numberOfSections, ownerId) => dispatch(SubscriptionActions.getSubscription(school, numberOfSections, ownerId)),
  deleteSchool: (ownerId, schoolId) => dispatch(SchoolInformationActions.deleteSchool(ownerId, schoolId)),
})
const mapStateToProps = (state, ownProps) => {
  return {
    schoolsSummary: state.schoolInformation.schoolsSummary,
    getSchoolsSummaryInProgress: state.schoolInformation.getSchoolsSummaryInProgress,
    i18n: state.i18nMessages.i18n,
    activeSchool: state.schoolInformation.activeSchool,
    getSubscriptionFailed: state.Subscription.getSubscriptionFailed,
    getSubscriptionInProgress: state.Subscription.getSubscriptionInProgress,
    cancelSubscriptionInProgress: state.Subscription.cancelSubscriptionInProgress,
    deleteSchoolInProgress: state.schoolInformation.deleteSchoolInProgress,
    userInformation: state.userProfile.userInformation,
    addMoreSectionsToSubscriptionInProgress: state.Subscription.addMoreSectionsToSubscriptionInProgress
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(SubscriptionContainer))